import React from "react";
import { Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import parser from "html-react-parser";

const JobDescription = ({ job }) => {
  const { t } = useTranslation();

  return (
      <React.Fragment>
        <Card>
          <CardBody>
            <h5 className="mb-3">{t("job_overview.job_description.title")}</h5>
            <p className="text-muted mb-2">{parser(job.description)}</p>
            {/* Commented out sections left unchanged */}
            {/*<div>
            <h5 className="mb-3">Responsibilities</h5>
            <p className="text-muted">Key responsibilities include:</p>
            <ul className="text-muted vstack gap-2">
              {job.responsibilities ? job.responsibilities.map((resp, idx) => (
                  <li key={idx}>{resp}</li>
              )) : (
                  <>
                    <li>Collaborate with team members to define and implement job requirements.</li>
                    <li>Ensure high-quality deliverables aligned with company standards.</li>
                    <li>Analyze and improve processes for efficiency.</li>
                  </>
              )}
            </ul>
          </div>
          <div>
            <h5 className="mb-3">Skills & Experience</h5>
            <ul className="text-muted vstack gap-2">
              {job.tags ? job.tags.map((tag, idx) => (
                  <li key={idx}>{tag}</li>
              )) : (
                  <>
                    <li>Relevant industry knowledge</li>
                    <li>Strong communication skills</li>
                    <li>Problem-solving abilities</li>
                  </>
              )}
              {job.experienceYears && <li>{job.experienceYears} of experience</li>}
            </ul>
          </div>*/}
          </CardBody>
        </Card>
      </React.Fragment>
  );
};

export default JobDescription;